/* Costumes: quick add to cart from the card button, then refresh the header cart count. */
(function () {
  if (window.__jvAddBound) return;
  window.__jvAddBound = true;
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-jvc-add]');
    if (!form) return;
    e.preventDefault();
    var box = form.closest('.jvc-card__add') || form;
    var drawer = document.querySelector('cart-drawer');
    var body = new FormData(form);
    if (drawer) {
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
    }
    fetch(form.action + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (added) {
        if (drawer && added && added.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(added);
          return null;
        }
        box.classList.add('is-added');
        setTimeout(function () { box.classList.remove('is-added'); }, 1600);
        return fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        if (!sections) return;
        var target = document.getElementById('cart-icon-bubble');
        if (!target || !sections || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var fresh = doc.querySelector('.shopify-section');
        if (fresh) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () { window.location.href = form.querySelector('input[name=id]') ? '/cart' : window.location.href; });
  });
})();
